if (!customElements.get('al-home-usp')) {
  customElements.define('al-home-usp', class extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('is-visible') ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
          !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.classList.add('is-visible');
        this.observer.disconnect();
      }, { threshold: 0.15 });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
